import {db, id} from "../../db";

export const useInitSetup = () => {
  const query = {
    profiles: {$avatar: {}, $workspace: {$logo: {}, shortcuts: {}, agents: {}}},
  };
  const {isLoading, error, data} = db.useQuery(query);
  return {isLoading, error, data};
};

export const useCreateWorkspace = () => {
  const createWorkspace = async ({
    userId,
    name,
    slug,
    userEmail,
  }: {
    userId: string;
    name: string;
    slug: string;
    userEmail: string;
  }) => {
    const workspaceId = id();
    const profileId = id();

    await db.transact([
      db.tx.workspaces[workspaceId]
        .update({name, slug, createdAt: new Date().toISOString(), status: true})
        .link({$user: userId}),

      db.tx.profiles[profileId]
        .update({
          email: userEmail,
          createdAt: new Date().toISOString(),
          status: true,
          key: `${userId}_${workspaceId}_owner`,
          role: "owner",
        })
        .link({$user: userId})
        .link({$workspace: workspaceId}),
    ]);

    return workspaceId;
  };

  return {createWorkspace};
};
